import React, { PureComponent } from "react";

import { branch } from "baobab-react/higher-order";
import PropTypes from "baobab-react/prop-types";

import { FontAwesomeIcon } from "../shared/FontAwesomeIconWrapper";
import autoBind from "react-autobind";

//import Clock from '../Clock';

import * as playerActions from "../../actions/playerActions";

import * as Utils from "../../utils/utils";
import themes from "../../constants/themes";

class Checkbar extends PureComponent {

	constructor(props) {
		super(props);
		autoBind(this);
	}



	_onLocate() {
		/*
		this.props.dispatch(
			Actions.setSpinnerVisible,
			true
		);
		*/
		this.props.dispatch(
			playerActions.showSelectedItem
		);
	}

	render() {

		const birdseyeIcon = this.props.sectionsMenuVisible?"list":"eye";

		const theme = window.activityTheme ? window.activityTheme : themes[(this.props.nightMode) ? "nightMode" : "default"];
		const { checkbarSize, checkbarLocation, checklistView, onLocate, onBirdseyeView, onEmergency, onShowShowMode, onCheck, onSkip } = this.props;
		
		const activity = this.context.tree.get(["activity"]);
		const touchbarButtons = [];
		const checkbarVisibility = Utils.getCheckbarVisibility(this.context.tree);

		if (checkbarLocation === "left" || checkbarLocation === "right" || (checkbarLocation === "hidden" && checkbarVisibility === "visible")) {
			if (Utils.hasList(this.context.tree, "Emergency")) {
				touchbarButtons.push(
					<div key="checkbarBirdseyeView" underlayColor="transparent" style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", flex: .50, width: checkbarSize, cursor: "pointer" }} onClick={onBirdseyeView}>
						<div style={{ display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: theme.checkbar.birdseyeView.bgColor, flex: 1, width: checkbarSize }}>
							<span style={{ color: theme.checkbar.birdseyeView.color }}><FontAwesomeIcon icon={birdseyeIcon} size={16} /></span>
						</div>
					</div>
				);
				touchbarButtons.push(
					<div key="checkbarLocateItem" underlayColor="transparent" style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", flex: .50, width: checkbarSize, cursor: "pointer" }} onClick={onLocate}>
						<div style={{ display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: theme.checkbar.locateItem.bgColor, flex: 1, width: checkbarSize }}>
							<span style={{ color: theme.checkbar.locateItem.color }}><FontAwesomeIcon icon={["fas", "binoculars"]} size={16} /></span>
						</div>
					</div>
				);

				touchbarButtons.push(
					<div key="checkbarEmergencyItem" underlayColor="transparent" style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", flex: .33, width: checkbarSize, cursor: "pointer"  }} onClick={onEmergency}>
						<div style={{ display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: theme.checkbar.emergency.bgColor, flex: 1, width: checkbarSize }}>
							<span style={{ color: theme.checkbar.emergency.color }}><FontAwesomeIcon icon={["fas", "exclamation-triangle"]} size={28} /></span>
						</div>
					</div>
				);
			} else {
				touchbarButtons.push(
					<div key="checkbarBirdseyeView" underlayColor="transparent" style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", flex: .5, cursor: "pointer"  }} onClick={onBirdseyeView}>
						<div style={{ display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: theme.checkbar.birdseyeView.bgColor, flex: 1, width: checkbarSize }}>
							<span style={{ color: theme.checkbar.birdseyeView.color }}><FontAwesomeIcon icon={birdseyeIcon} size={16} /></span>
						</div>
					</div>
				);
				touchbarButtons.push(
					<div key="checkbarLocateItem" underlayColor="transparent" style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", flex: .5, cursor: "pointer"  }} onClick={onLocate}>
						<div style={{ display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: theme.checkbar.locateItem.bgColor, flex: 1, width: checkbarSize }}>
							<span style={{ color: theme.checkbar.locateItem.color }}><FontAwesomeIcon icon={["fas", "binoculars"]} size={16} /></span>
						</div>
					</div>
				);
			}

			if (activity && activity.allowSwitchToShowMode) {
				touchbarButtons.push(
					<div key="switchToShowMode" underlayColor="transparent" style={{ display: "flex", flexDirection: "column", flex: .5, cursor: "pointer"  }} onClick={onShowShowMode}>
						<div style={{ display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: theme.checkbar.switchShowMode.bgColor, flex: 1, width: checkbarSize }}>
							<span style={{ color: theme.checkbar.switchShowMode.color }}><FontAwesomeIcon icon={["fas", "image"]} size={20} /></span>
						</div>
					</div>
				);
			}
		} else {
			if (Utils.hasList(this.context.tree, "Emergency")) {
				touchbarButtons.push(
					<div key="checkbarBirdseyeView" underlayColor="transparent" style={{ display: "flex", flexDirection: "row", flex: .5, height: checkbarSize, cursor: "pointer"  }} onClick={onBirdseyeView} >
						<div style={{ display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: theme.checkbar.birdseyeView.bgColor, flex: 1, height: checkbarSize }}>
							<span style={{ color: theme.checkbar.birdseyeView.color }}><FontAwesomeIcon icon={birdseyeIcon} size={16} /></span>
						</div>
					</div>
				);
				touchbarButtons.push(
					<div key="checkbarLocateItem" underlayColor="transparent" style={{ display: "flex", flexDirection: "row", flex: .5, height: checkbarSize, cursor: "pointer"  }} onClick={onLocate} >
						<div style={{ display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: theme.checkbar.locateItem.bgColor, flex: 1, height: checkbarSize }}>
							<span style={{ color: theme.checkbar.locateItem.color }}><FontAwesomeIcon icon={["fas", "binoculars"]} size={16} /></span>
						</div>
					</div>
				);

				touchbarButtons.push(
					<div key="checkbarEmergencyItem" underlayColor="transparent" style={{ display: "flex", flexDirection: "row", flex: .33, height: checkbarSize, cursor: "pointer"  }} onClick={onEmergency}>
						<div style={{ display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: theme.checkbar.emergency.bgColor, flex: 1, height: checkbarSize }}>
							<span style={{ color: theme.checkbar.emergency.color }}><FontAwesomeIcon icon={["fas", "exclamation-triangle"]} size={28} /></span>
						</div>
					</div>
				);
			} else {
				touchbarButtons.push(
					<div key="checkbarBirdseyeView" underlayColor="transparent" style={{ display: "flex", flexDirection: "row", flex: .5, cursor: "pointer"  }} onClick={onBirdseyeView}>
						<div style={{ display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: theme.checkbar.birdseyeView.bgColor, flex: 1, height: checkbarSize }}>
							<span style={{ color: theme.checkbar.birdseyeView.color }}><FontAwesomeIcon icon={birdseyeIcon} size={16} /></span>
						</div>
					</div>
				);	
				touchbarButtons.push(
					<div key="checkbarLocateItem" underlayColor="transparent" style={{ display: "flex", flexDirection: "row", flex: .5, cursor: "pointer"  }} onClick={onLocate}>
						<div style={{ display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: theme.checkbar.locateItem.bgColor, flex: 1, height: checkbarSize }}>
							<span style={{ color: theme.checkbar.locateItem.color }}><FontAwesomeIcon icon={["fas", "binoculars"]} size={16} /></span>
						</div>
					</div>
				);	
			}
			if (activity && activity.allowSwitchToShowMode) {
				touchbarButtons.push(
					<div key="switchToShowMode" underlayColor="transparent" style={{ display: "flex", flexDirection: "row", flex: .5, cursor: "pointer"  }} onClick={onShowShowMode}>
						<div style={{ display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: theme.checkbar.switchShowMode.bgColor, flex: 1, height: checkbarSize }}>
							<span style={{ color: theme.checkbar.switchShowMode.color }}><FontAwesomeIcon icon={["fas", "image"]} size={20} /></span>
						</div>
					</div>
				);
			}

		}

		let checkbar;
		if (checkbarLocation === "left" || checkbarLocation === "right" || (checkbarLocation === "hidden" && checkbarVisibility === "visible")) {
			checkbar =
				<div key={"checkbar-" + checklistView} style={{ display: "flex", flexDirection: "column", width: checkbarSize, alignItems: "flex-start", justifyContent: "center", flex: 1}}>
					<div underlayColor="transparent" style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", flex: 1, width: checkbarSize, cursor: "pointer"  }} onClick={onSkip}>
						<div style={{ display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: theme.checkbar.skip.bgColor, flex: 1, width: checkbarSize }}>
						<span style={{ color: theme.checkbar.skip.color }}><FontAwesomeIcon icon={["fas", "step-forward"]} size={16} /></span>
						</div>
					</div>
					<div underlayColor="transparent" style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", flex: 1, width: checkbarSize, cursor: "pointer"  }} onClick={onCheck}>
						<div style={{ display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: theme.checkbar.check.bgColor, flex: 1, width: checkbarSize }}>
							<span style={{ color: theme.checkbar.check.color }}><FontAwesomeIcon icon={["fas", "check-square"]} size={16} /></span>
						</div>
					</div>
					{touchbarButtons}
				</div>;
		} else {
			checkbar =
				<div key={"checkbar-" + checklistView} style={{display: "flex", height: checkbarSize, flexDirection: "row", alignItems: "center", justifyContent: "flex-start", flex: 1 }}>
					<div underlayColor="transparent" style={{ display: "flex", flex: 1, cursor: "pointer", height: checkbarSize }} onClick={onCheck}>
						<div style={{ display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: theme.checkbar.check.bgColor, flex: 1 }}>
							<span style={{ color: theme.checkbar.check.color }}><FontAwesomeIcon icon={["fas", "check-square"]} size={16} /></span>
						</div>
					</div>
					<div underlayColor="transparent" style={{ display: "flex", flex: 1, cursor: "pointer", height: checkbarSize }} onClick={onSkip}>
						<div style={{ display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: theme.checkbar.skip.bgColor, flex: 1 }}>
						<span style={{ color: theme.checkbar.skip.color }}><FontAwesomeIcon icon={["fas", "step-forward"]} size={16} /></span>
						</div>
					</div>
					{touchbarButtons}
				</div>;
		}

		return checkbar;
	}
}

Checkbar.contextTypes = {
	tree: PropTypes.baobab
};

export default branch({
	sectionsMenuVisible: ["appState","sectionsMenuVisible"],
	nightMode: ["nightMode"],
	checklistView: ["checklistView"],
	checkbarSize: ["appPreferences", "checkbarSize"],
	checkbarLocation: ["appPreferences", "checkbarLocation"]
}, Checkbar);